module.exports = {
  fieldRequired: [field => !!field || 'Field is required'],

  numberRequired: [
    field => /^([0-9]{1,9})$/.test(field) ||
      'Valid number value is required'
  ]
}
